<template>
    <div>
        <v-row>
            
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-list>
                                <template v-for="(log, index) in callLogs">
                                    <v-list-item :key="'a' + index" @click="test">
                                        {{ log.type }}
                                    </v-list-item>
                                    <v-divider :key="'b' + index" />
                                </template>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            callLogs: [
                {
                    type: 'Akademi',
                    dato: '2020-08-12'
                },
                {
                    type: 'Kvalitet',
                    dato: '2020-08-10'
                },
                {
                    type: 'Kvalitet',
                    dato: '2020-08-07'
                },
                {
                    type: 'Onboarding',
                    dato: '2020-08-07'
                }
            ]
        }
    },
    methods: {
        test () {
            // console.log('test')
        }
    }
}
</script>